// Unpublished Work © 2026 Deere & Company.

import {getCurrencySymbol} from 'Utils/unit-conversion-utils';

function formatLaborReportWorksheetValues({
    worksheet,
    includeDate,
    currencyPreference,
    hasViewFinancialDataPermission
}) {
    const currencySymbol = getCurrencySymbol({
        currencyPreference
    });

    const NUMBER_FORMAT = '#,##0.00';
    const CURRENCY_FORMAT = `"${currencySymbol}"${NUMBER_FORMAT}`;

    const formats = {
        estDuration: NUMBER_FORMAT,
        actualDuration: NUMBER_FORMAT,
        overtimeDuration: NUMBER_FORMAT,
        estLaborCost: CURRENCY_FORMAT,
        laborCost: CURRENCY_FORMAT,
        overtimeCost: CURRENCY_FORMAT
    };

    [
        'name',
        ...includeDate ? ['dateSelect'] : [],
        'estDuration',
        ...hasViewFinancialDataPermission ? ['estLaborCost'] : [],
        'actualDuration',
        ...hasViewFinancialDataPermission ? ['laborCost'] : [],
        'overtimeDuration',
        ...hasViewFinancialDataPermission ? ['overtimeCost'] : []
    ].forEach((key, index) => {
        if (formats[key]) {
            worksheet.getColumn(index + 1).numFmt = formats[key];
        }
    });
}

export {
    formatLaborReportWorksheetValues
};
